import type { CapabilityBinding } from '../../core/types';

/** BareMetal 能力绑定（layout / headless 注册用） */
export const BARE_METAL_CAPABILITIES = [
  {
    key: 'base-info',
    pathPrefix: '',
    options: { nameMaxLength: 63, descriptionMaxLength: 256 },
  },
  {
    key: 'network',
    pathPrefix: '',
    options: { showSecurityGroup: true, showStaticIpv4WhenAdopt: true },
  },
  {
    key: 'bare-metal-provisioning',
    pathPrefix: '',
  },
  {
    key: 'image',
    pathPrefix: '',
    options: {
      imageFieldPrefix: 'image',
      imageListVariant: 'common',
      legacyFlatFields: false,
      hideWhen: { field: 'provisioning.mode', value: 'Adopt' },
    },
  },
  {
    key: 'power-policy',
    pathPrefix: '',
  },
  {
    key: 'bare-metal-nodes',
    pathPrefix: '',
  },
  {
    key: 'service',
    pathPrefix: '',
    options: { listSegment: 'service', requireAtLeastOne: false },
  },
] as const satisfies readonly CapabilityBinding[];
